export class ProviderSearchModel  {
  query: string = '';
  fundUsiList: string[] = [];
}

